module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-light-300.0b4313e0.woff";